/* PostcodeLookup/Select.svelte generated by Svelte v3.24.0 */
import {
	SvelteComponent,
	append,
	attr,
	destroy_each,
	detach,
	element,
	empty,
	init,
	insert,
	listen,
	noop,
	prevent_default,
	safe_not_equal,
	set_data,
	space,
	stop_propagation,
	text
} from "svelte/internal";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i][0];
	child_ctx[5] = list[i][1];
	return child_ctx;
}

// (19:4) {:else}
function create_else_block(ctx) {
	let option;

	return {
		c() {
			option = element("option");
			option.textContent = "No addresses found";
			option.__value = "No addresses found";
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (14:4) {#if addresses && addresses.length > 0}
function create_if_block(ctx) {
	let option;
	let each_1_anchor;
	let each_value = /*addresses*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			option = element("option");
			option.textContent = "Choose address...";

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
			option.selected = true;
			option.disabled = true;
			option.__value = "Choose address...";
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*addresses*/ 1) {
				each_value = /*addresses*/ ctx[0];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d(detaching) {
			if (detaching) detach(option);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (16:6) {#each addresses as [value, text]}
function create_each_block(ctx) {
	let option;
	let t_value = /*text*/ ctx[5] + "";
	let t;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t = text(t_value);
			option.__value = option_value_value = /*value*/ ctx[4];
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t);
		},
		p(ctx, dirty) {
			if (dirty & /*addresses*/ 1 && t_value !== (t_value = /*text*/ ctx[5] + "")) set_data(t, t_value);

			if (dirty & /*addresses*/ 1 && option_value_value !== (option_value_value = /*value*/ ctx[4])) {
				option.__value = option_value_value;
				option.value = option.__value;
			}
		},
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let label;
	let t0;
	let label_class_value;
	let t1;
	let select;
	let select_class_value;
	let div_class_value;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*addresses*/ ctx[0] && /*addresses*/ ctx[0].length > 0) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			label = element("label");
			t0 = text("Select your address");
			t1 = space();
			select = element("select");
			if_block.c();
			attr(label, "class", label_class_value = /*classNames*/ ctx[1].label);
			attr(label, "for", "select-address");
			attr(select, "class", select_class_value = /*classNames*/ ctx[1].select);
			attr(select, "id", "select-address");
			attr(div, "data-testid", "container");
			attr(div, "class", div_class_value = /*classNames*/ ctx[1].container);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, label);
			append(label, t0);
			append(div, t1);
			append(div, select);
			if_block.m(select, null);

			if (!mounted) {
				dispose = listen(select, "change", stop_propagation(prevent_default(/*onChange*/ ctx[2])));
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*classNames*/ 2 && label_class_value !== (label_class_value = /*classNames*/ ctx[1].label)) {
				attr(label, "class", label_class_value);
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(select, null);
				}
			}

			if (dirty & /*classNames*/ 2 && select_class_value !== (select_class_value = /*classNames*/ ctx[1].select)) {
				attr(select, "class", select_class_value);
			}

			if (dirty & /*classNames*/ 2 && div_class_value !== (div_class_value = /*classNames*/ ctx[1].container)) {
				attr(div, "class", div_class_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if_block.d();
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { addresses } = $$props;
	let { classNames = {} } = $$props;
	let { onSelected = () => null } = $$props;
	const onChange = e => onSelected(e.target.value);

	$$self.$set = $$props => {
		if ("addresses" in $$props) $$invalidate(0, addresses = $$props.addresses);
		if ("classNames" in $$props) $$invalidate(1, classNames = $$props.classNames);
		if ("onSelected" in $$props) $$invalidate(3, onSelected = $$props.onSelected);
	};

	return [addresses, classNames, onChange, onSelected];
}

class Select extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			addresses: 0,
			classNames: 1,
			onSelected: 3
		});
	}
}

export default Select;